import { Modal } from 'antd';
import styled from 'styled-components';
import classNames from 'classnames';
import { primaryHeadingColor, sadGilroyFace, secondaryFont, wMBold } from '../../../Utils/utilsStyle';
import { actions } from '../../../Slice/PersonProfileSlice';
import { useDispatch } from 'react-redux';
const PopupModal = styled(Modal)`
  &.remove-alignment-modal {
    .ant-modal-body {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      row-gap: 12px;
      .modal-text {
        color: ${primaryHeadingColor};
        text-align: center;
        font-family: ${secondaryFont};
        font-size: 22px;
        font-weight: ${wMBold};
        line-height: 28.491px;
        letter-spacing: -0.95px;
      }
    }
    .ant-modal-footer {
      .ant-btn {
        min-width: 100px !important;
        border-radius: 22px;
        padding: 8px 16px;
        font-size: 14px;
        line-height: normal;

      }
    }
  }
`;

type Props = {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  rowId: number;
} & typeof defaultProps;

const defaultProps = {
  isVisible: false,
  rowId: -1,
};

const RemoveAlignmentModal = function RemoveAlignmentModal(props: Props) {
  const { isVisible, setIsVisible, rowId } = props;
  const dispatch = useDispatch();
  const removeRow = () => {
    if (rowId === null) return;
    dispatch(actions.removeAlignmentRow(rowId));
    setIsVisible(false);
  }
  return (
    <PopupModal
      open={isVisible}
      onCancel={() => setIsVisible(false)}
      onOk={removeRow}
      cancelText="Cancel"
      okText="Delete"
      closeIcon={null}
      width="528px"
      centered={true}
      className={classNames('remove-alignment-modal')}
    >
      <img src={sadGilroyFace} alt="sad-gilroy" className="gilroy-white-svg" />
      <span className='modal-text'>
        Do you want to remove this sales alignment?
        All profiles associated will be permanently removed.
      </span>

    </PopupModal>
  );
};

RemoveAlignmentModal.defaultProps = defaultProps;
export default RemoveAlignmentModal;